import { config_UPTIME } from "../Constants";
import { AUTHENTICATE_2FA, GENERATE_2FA } from "../actions/2fa";
import {
  apiRequest,
  apiRequestCHATHISTORY,
  apiRequestCREATEMACHINE,
  apiRequestCopilot,
  apiRequestJOINEDCHATROOMS,
  apiRequestMACHINES,
  apiRequestUSERS,
  apiSearchHeaderRequest,
} from "../actions/api";
import { LOGIN } from "../actions/auth";
import { CHATROOMS, JOINCHAT, MESSAGES, SENDMESSAGE } from "../actions/chat";
import { COSTTYPES, COST_CREATE, COST_UPDATE } from "../actions/costs";
import {
  COUNTERS,
  COUNTER_CREATE,
  COUNTER_TYPES,
  COUNTER_TYPE_CREATE,
  DELETECOUNTER,
  GET_UNITS,
  UPDATECOUNTER,
} from "../actions/counters";
import { DELETE_USER_TOKEN, MARKREADNOTIFICATION } from "../actions/keyvalue";
import { KPIS } from "../actions/kpis";
import {
  // COPILOT_QUERRY,
  CREATE_FAQ,
  CREATE_LEGALENTITIES,
  CREATE_MACHINE,
  CREATE_MACHINE_CE,
  CREATE_MACHINE_POOL,
  CREATE_MAINTENANCE_TASK,
  CREATE_TYPE,
  DELETE_FAQ,
  DELETE_MACHINE,
  DELETE_MACHINE_CE,
  DELETE_MACHINE_POOL,
  DELETE_MAINTENANCE_TASK,
  DELETE_MAINTENANCE_TASK_TEMPLATE,
  ENTERPRISES_TYPES,
  GET_LEGAL_ENTITIES,
  GET_MACHINE_POOLS_OF_USER,
  MAINTENANCE_TASK_TEMPLATES,
  SINGLE_MACHINE,
  SINGLE_MACHINE_CE,
  UPDATE_FAQ,
  UPDATE_MACHINE,
  UPDATE_MACHINE_CE,
  UPDATE_MACHINE_DOCUMENT,
  UPDATE_MACHINE_POOL,
  UPDATE_MAINTENANCE_TASK,
  getLegalEntities,
} from "../actions/machines";
import {
  ASSIGN_NOTIFICATIONS,
  ATTACHMENTS_TYPES,
  AUFGABE_NOTIFICATIONS,
  CREATE_NOTIFICATION,
  CREATE_REPORT,
  CREATE_WORK_FLOW_STEP,
  DELETE_NOTIFICATION,
  NOTIFICATION,
  NOTIFICATIONS,
  SHARE_NOTIFICATION,
  UPDATE_NOTIFICATION,
  UPDATE_REPORT,
  UPDATE_WORK_FLOW_STEP,
} from "../actions/notification";
import {
  ADD_CATEGORY,
  ALL_CATEGORIES,
  ALL_SITES_AREAS_EQS,
  ASSIGN_SAE,
  BRANDS_TYPES_EQUIPMENTS,
  CREATE_AREA,
  CREATE_AREA_SHIFTS,
  UPDATE_AREA_SHIFTS,
  CREATE_BRAND,
  CREATE_CLASS,
  CREATE_EQUIPMENT_TYPE,
  CREATE_GENERIC_ATTACHMENT,
  DELETE_AREA,
  DELETE_BRAND,
  DELETE_CATEGORY,
  DELETE_GENERIC_ATTACHMENT,
  DELETE_SITE,
  EDIT_CATEGORY,
  EQUIPMENT_CLASSES,
  EQUIPMENT_TYPES,
  REFRESH_TOKEN,
  SINGLE_EQUIPMENT_TYPE,
  SITES_AREAS_EQS,
  SITES_AREAS_EQS2,
  UPDATE_AREA,
  UPDATE_BRAND,
  UPDATE_CLASS,
  UPDATE_SITE,
  CREATE_SITE,
  CREATE_EQUIPMENT_POOL_MAP,
} from "../actions/objects";
import { HEADER_SEARCH } from "../actions/search";
import { CREATE_CLIENT, GET_ALL_LE } from "../actions/super";
import {
  CHECK_USER,
  CREATEUSER,
  GETALLUSER,
  GETUSERBYNODEID,
  GET_ALL_ACL_USERS,
  REGISTER_USER,
  RESENDEMAIL,
  RESETPASSWORD,
  SEARCH_USER,
  SETPASSWORD,
  UPDATE_USERINFO,
  UPDATEUSER,
  SUBMIT_ORDER_SUBS,
  SUBMIT_SIGNUP_USER,
  DELETEUSER,
  GETSUPPORTJSON,
  POSTFEEDBACK,
} from "../actions/user";
import { getItem } from "../utils/DataProtection";

const SERVER_URL = config_UPTIME.url.API_URL;
const COPILOT_URL = config_UPTIME.url.COPILOT_URL;
const SERVER_URL_FCM = `https://uptime.service.247uptime.io`;

const lang = "de";

export const appMiddleware = () => (next) => (action) => {

  next(action);
  switch (action.type) {
    /** Authentication */

    //#region

    case LOGIN: {
      next(
        apiRequest({
          url: `${SERVER_URL}/auth/login`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case SUBMIT_ORDER_SUBS: {
      next(
        apiRequest({
          url: `${SERVER_URL}/users/ordersubscriptions`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case SUBMIT_SIGNUP_USER: {
      next(
        apiRequest({
          url: `${SERVER_URL}/users/signup`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    //Header Search

    case HEADER_SEARCH: {
      next(
        apiSearchHeaderRequest({
          url: `${SERVER_URL}/search`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    //#endregion

    /** Notification */

    //#region
    case CREATE_NOTIFICATION: {
      next(
        apiRequest({
          url: `${SERVER_URL}/notifications`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case NOTIFICATION: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/notifications/` +
            encodeURIComponent(action.payload.nodeid) +
            "?lang=" +
            lang,
          method: "GET",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    // case COPILOT_QUERRY: {
    //   next(
    //     apiRequestCopilot({
    //       url: `${COPILOT_URL}/query/`,
    //       method: "POST",
    //       data: action.payload,
    //     })
    //   );
    //   break;
    // }

    case NOTIFICATIONS: {
      next(
        apiRequest({
          url: `${SERVER_URL}/notifications/equipments`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case AUFGABE_NOTIFICATIONS: {
      next(
        apiRequest({
          url: `${SERVER_URL}/notifications/unassigned`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }


    case ASSIGN_NOTIFICATIONS: {
      next(
        apiRequest({
          url: `${SERVER_URL}/notifications/assigned`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case UPDATE_NOTIFICATION: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/notifications/` +
            encodeURIComponent(action.payload.nodeid),
          method: "PUT",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case DELETE_NOTIFICATION: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/notifications/` +
            encodeURIComponent(action.payload.nodeid),
          method: "DELETE",
          data: {},
        })
      );
      break;
    }

    case SHARE_NOTIFICATION: {
      next(
        apiRequest({
          url: `${SERVER_URL}/notifications/share`,
          method: "POST",
          data: action.payload,
          op: "noti_email",
        })
      );
      break;
    }

    //#endregion

    /** EquipmentPools */
    //#region

    case CREATE_MACHINE_POOL: {
      next(
        apiRequest({
          url: `${SERVER_URL}/equipmentpools`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATE_MACHINE_POOL: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/equipmentpools/` +
            encodeURIComponent(action.payload.equipmentpoolnodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETE_MACHINE_POOL: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/equipmentpools/` +
            encodeURIComponent(action.payload.equipmentpoolnodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }

    case GET_MACHINE_POOLS_OF_USER: {
      const usernodeid = getItem("usernodeid");
      next(
        apiRequest({
          url:
            `${SERVER_URL}/equipmentpools?usernodeid=` +
            encodeURIComponent(JSON.parse(usernodeid)) +
            "&lang=" +
            lang,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    //#endregion

    /** Equipment */

    //#region

    case GET_LEGAL_ENTITIES: {
      next(
        apiRequest({
          url: `${SERVER_URL}/getlebrty/?includeTypes=true&includeBrands=true`,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    case SINGLE_MACHINE: {
      next(
        apiRequestMACHINES({
          url:
            `${SERVER_URL}/equipments/` +
            encodeURIComponent(action.payload) +
            "?lang=" +
            lang,
          method: "GET",
          data: {},
        })
      );
      break;
    }

    case CREATE_MACHINE: {
      next(
        apiRequestCREATEMACHINE({
          url: `${SERVER_URL}/equipments`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATE_MACHINE: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/equipments/` +
            encodeURIComponent(action.payload.equipmentnodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETE_MACHINE: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/equipments/` +
            encodeURIComponent(action.payload.nodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }

    /* counters */
    case COUNTER_CREATE: {
      next(
        apiRequest({
          url: `${SERVER_URL}/counters/create`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case COUNTERS: {
      next(
        apiRequest({
          url: `${SERVER_URL}/counters?lang=${lang}`,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    case UPDATECOUNTER: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/counters/update/` +
            encodeURIComponent(action.payload.nodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETECOUNTER: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/counters/delete/` +
            encodeURIComponent(action.payload.nodeid),
          method: "DELETE",
        })
      );
      break;
    }

    /* counter types */

    case COUNTER_TYPE_CREATE: {
      next(
        apiRequest({
          url: `${SERVER_URL}/countertypes/create`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case COUNTER_TYPES: {
      next(
        apiRequest({
          url: `${SERVER_URL}/countertypes?lang=${lang}`,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    /* costs */

    case COST_CREATE: {
      next(
        apiRequest({
          url: `${SERVER_URL}/costs/create`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case COST_UPDATE: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/costs/update/` +
            encodeURIComponent(action.payload.nodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    /* cost types */

    case COSTTYPES: {
      next(
        apiRequest({
          url: `${SERVER_URL}/costtypes?lang=${lang}`,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    /* case EQUIPMENT_STREAM: {
      next(
        apiRequest({
          url: `${SERVER_URL}/streams/equipments`,
          method: "POST",
          data:action.payload,
          op:action.optype
        })
      );
      break;
    } */

    //#endregion

    /** Customer Equipment */

    //#region

    case SINGLE_MACHINE_CE: {
      next(
        apiRequestMACHINES({
          url:
            `${SERVER_URL}/customerequipments/` +
            encodeURIComponent(action.payload) +
            "?lang=" +
            lang,
          method: "GET",
          data: {},
        })
      );
      break;
    }

    case CREATE_MACHINE_CE: {
      next(
        apiRequestCREATEMACHINE({
          url: `${SERVER_URL}/customerequipments`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATE_MACHINE_CE: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/customerequipments/` +
            encodeURIComponent(action.payload.attachmentnodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETE_MACHINE_CE: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/customerequipments/` +
            encodeURIComponent(action.payload.nodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }

    //#endregion

    /** Users */

    //#region

    case CREATEUSER: {
      next(
        apiRequest({
          url: `${SERVER_URL}/users`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case DELETEUSER: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/users/` + encodeURIComponent(action.payload.nodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }

    case REGISTER_USER: {
      next(
        apiRequest({
          url: `${SERVER_URL}/users/freeuser`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case CHECK_USER: {
      next(
        apiRequest({
          url: `${SERVER_URL}/users/check/` + action.payload.email,
          method: "GET",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case GETUSERBYNODEID: {
      const usernodeid = JSON.parse(getItem("usernodeid"));
      next(
        apiRequest({
          url: `${SERVER_URL}/users/` + encodeURIComponent(usernodeid),
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    case SETPASSWORD: {
      next(
        apiRequest({
          url: `${SERVER_URL}/users/set-password`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case RESETPASSWORD: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/users/reset-password/` +
            encodeURIComponent(action.payload.email),
          method: "POST",
          data: {},
        })
      );
      break;
    }
    case RESENDEMAIL: {
      next(
        apiRequest({
          url: `${SERVER_URL}/users/resend-email`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATEUSER: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/users/` + encodeURIComponent(action.payload.nodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATE_USERINFO: {
      next(
        apiRequest({
          url: `${SERVER_URL}/userinfo/update`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case GETALLUSER: {
      const legalentitynodeid = getItem("legalentitynodeid");
      next(
        apiRequestUSERS({
          url:
            `${SERVER_URL}/users?legalentitynodeid=` +
            encodeURIComponent(JSON.parse(legalentitynodeid)),
          method: "GET",
          data: {},
        })
      );
      break;
    }

    case GETSUPPORTJSON: {
      next(
        apiRequest({
          url: `${SERVER_URL}/support`,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    case POSTFEEDBACK: {
      next(
        apiRequest({
          url: `${SERVER_URL}/feedback`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case SEARCH_USER: {
      next(
        apiRequest({
          url: `${SERVER_URL}/users/search`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case GET_ALL_ACL_USERS: {
      const clientid = JSON.parse(getItem("clientid"));
      next(
        apiRequest({
          url: `${SERVER_URL}/users/acl/` + clientid,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }
    //#endregion

    /** Chats */
    //#region
    case SENDMESSAGE: {
      next(
        apiRequest({
          url: `${SERVER_URL}/chatmessages`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case MESSAGES: {
      const chatroomnodeid = getItem("chatroomnodeid");
      next(
        apiRequestCHATHISTORY({
          url: `${SERVER_URL}/chatrooms/` + encodeURIComponent(chatroomnodeid),
          method: "GET",
          data: {},
        })
      );
      break;
    }

    case JOINCHAT: {
      next(
        apiRequest({
          url: `${SERVER_URL}/chatrooms/join`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case CHATROOMS: {
      const usernodeid = getItem("usernodeid");
      next(
        apiRequestJOINEDCHATROOMS({
          url:
            `${SERVER_URL}/chatrooms?usernodeid=` +
            encodeURIComponent(JSON.parse(usernodeid)) +
            "&lang=" +
            lang,
          method: "GET",
          data: {},
        })
      );
      break;
    }
    //#endregion

    /** Attachments */

    //#region
    case CREATE_GENERIC_ATTACHMENT: {
      next(
        apiRequest({
          url: `${SERVER_URL}/attachments`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case UPDATE_MACHINE_DOCUMENT: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/attachments/` +
            encodeURIComponent(action.payload.attachmentnodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETE_GENERIC_ATTACHMENT: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/attachments/` +
            encodeURIComponent(action.payload.nodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }
    //#endregion

    /** Sites */

    //#region

    case CREATE_SITE: {
      next(
        apiRequest({
          url: `${SERVER_URL}/sites`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case CREATE_EQUIPMENT_POOL_MAP: {
      next(
        apiRequest({
          url: `${SERVER_URL}/assign/equipments`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATE_SITE: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/sites/` +
            encodeURIComponent(action.payload.sitenodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETE_SITE: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/sites/` +
            encodeURIComponent(action.payload.sitenodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }

    //#endregion

    /** Areas */
    //#region

    case CREATE_AREA: {
      next(
        apiRequest({
          url: `${SERVER_URL}/areas`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case CREATE_AREA_SHIFTS: {
      next(
        apiRequest({
          url: `${SERVER_URL}/shiftmodel`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }


    case UPDATE_AREA_SHIFTS: {
      let shifts = {shifts: action.payload.shifts};
      next(
        apiRequest({
          url: `${SERVER_URL}/shiftmodel/`+
          encodeURIComponent(action.payload.shiftnodeid),
          method: "PUT",
          data: shifts,
        })
      );
      break;
    }


    case UPDATE_AREA: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/areas/` +
            encodeURIComponent(action.payload.areanodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETE_AREA: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/areas/` +
            encodeURIComponent(action.payload.areanodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }
    //#endregion

    /** Clients */
    //#region
    case GET_ALL_LE: {
      next(
        apiRequest({
          url: `${SERVER_URL}/auth/clients` + "?lang=" + lang,
          method: "GET",
        })
      );
      break;
    }

    case CREATE_CLIENT: {
      // //console.log(action.payload);

      next(
        apiRequest({
          url: `${SERVER_URL}/auth/clients`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    //#endregion

    /** Key Value Store DB */

    //#region

    case MARKREADNOTIFICATION: {
      next(
        apiRequest({
          url: `${SERVER_URL}/keyvalue/delete`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case DELETE_USER_TOKEN: {
      next(
        apiRequest({
          url: `${SERVER_URL}/keyvalue/delete`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    //#endregion

    /** WorkFlows */

    //#region
    case CREATE_WORK_FLOW_STEP: {
      next(
        apiRequest({
          url: `${SERVER_URL}/workflows`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATE_WORK_FLOW_STEP: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/workflows/` +
            encodeURIComponent(action.payload.workflownodeid),
          method: "PUT",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    //#endregion

    /** Reports */
    //#region

    case CREATE_REPORT: {
      next(
        apiRequest({
          url: `${SERVER_URL}/reports`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATE_REPORT: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/reports/` +
            encodeURIComponent(action.payload.reportnodeid),
          method: "PUT",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }
    //#endregion

    /** Faqs */

    //#region
    case CREATE_FAQ: {
      next(
        apiRequest({
          url: `${SERVER_URL}/faqs`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATE_FAQ: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/faqs/` +
            encodeURIComponent(action.payload.questionanswernodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETE_FAQ: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/faqs/` + encodeURIComponent(action.payload.nodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }

    //#endregion

    /** Maintenance Categories */

    //#region

    case ADD_CATEGORY: {
      next(
        apiRequest({
          url: `${SERVER_URL}/maintenancecategories`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case ALL_CATEGORIES: {
      next(
        apiRequest({
          url: `${SERVER_URL}/maintenancecategories` + "?lang=" + lang,
          method: "GET",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case EDIT_CATEGORY: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/maintenancecategories/` +
            encodeURIComponent(action.payload.categorynodeid),
          method: "PUT",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case DELETE_CATEGORY: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/maintenancecategories/` +
            encodeURIComponent(action.payload.maintenancecategorynodeid),
          method: "DELETE",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    //#endregion

    /** Maintenance Tasks */
    //#region
    case CREATE_MAINTENANCE_TASK: {
      next(
        apiRequest({
          url: `${SERVER_URL}/maintenancetasks`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case MAINTENANCE_TASK_TEMPLATES: {
      const legalentitynodeid = JSON.parse(getItem("legalentitynodeid"));

      next(
        apiRequest({
          url: `${SERVER_URL}/lemaintenancetasks?lang=${lang}&&legalentitynodeid=${legalentitynodeid}`,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    case DELETE_MAINTENANCE_TASK_TEMPLATE: {
      const legalentitynodeid = JSON.parse(getItem("legalentitynodeid"));
      next(
        apiRequest({
          url: `${SERVER_URL}/maintenancetasktemplate?legalentitynodeid=${legalentitynodeid}&maintenancetasknodeid=${action.payload}`,
          method: "DELETE",
          op: action.optype
        })
      );
      break;

    }

    case UPDATE_MAINTENANCE_TASK: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/maintenancetasks/` +
            encodeURIComponent(action.payload.maintenancetasknodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETE_MAINTENANCE_TASK: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/maintenancetasks/` +
            encodeURIComponent(action.payload.maintenancetasknodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }

    //#endregion

    /**Equipment Types */
    //#region
    case CREATE_EQUIPMENT_TYPE: {
      next(
        apiRequestCREATEMACHINE({
          url: `${SERVER_URL}/equipmenttypes`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case EQUIPMENT_TYPES: {
      next(
        apiRequestCREATEMACHINE({
          url: `${SERVER_URL}/equipmenttypes`,
          method: "GET",
          data: {},
        })
      );
      break;
    }
    //#endregion

    /** Brands */
    //#region
    case CREATE_BRAND: {
      next(
        apiRequest({
          url: `${SERVER_URL}/brands`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case UPDATE_BRAND: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/brands/` + encodeURIComponent(action.payload.nodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }

    case DELETE_BRAND: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/brands/` + encodeURIComponent(action.payload.nodeid),
          method: "DELETE",
          data: action.payload,
        })
      );
      break;
    }
    //#endregion

    case CREATE_TYPE: {
      next(
        apiRequest({
          url: `${SERVER_URL}/equipmenttypes`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    case CREATE_LEGALENTITIES: {
      next(
        apiRequest({
          url: `${SERVER_URL}/legalentities`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }

    /** Equipment Classes */
    //#region
    case EQUIPMENT_CLASSES: {
      next(
        apiRequestCREATEMACHINE({
          url: `${SERVER_URL}/equipmentclasses` + "?lang=" + lang,
          method: "GET",
          data: {},
        })
      );
      break;
    }

    case CREATE_CLASS: {
      next(
        apiRequest({
          url: `${SERVER_URL}/equipmentclasses`,
          method: "POST",
          data: action.payload,
        })
      );
      break;
    }
    case UPDATE_CLASS: {
      next(
        apiRequest({
          url:
            `${SERVER_URL}/equipmentclasses/` +
            encodeURIComponent(action.payload.nodeid),
          method: "PUT",
          data: action.payload,
        })
      );
      break;
    }
    //#endregion

    case REFRESH_TOKEN: {
      next(
        apiRequest({
          url: `${SERVER_URL}/object/refresh-token`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case ATTACHMENTS_TYPES: {
      next(
        apiRequest({
          url: `${SERVER_URL}/files/all`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case ENTERPRISES_TYPES: {
      next(
        apiRequestCREATEMACHINE({
          url: `${SERVER_URL}/brands`,
          method: "GET",
          data: {},
        })
      );
      break;
    }

    case SINGLE_EQUIPMENT_TYPE: {
      next(
        apiRequestMACHINES({
          url:
            `${SERVER_URL}/equipmenttypes/` +
            encodeURIComponent(action.payload) +
            "?lang=" +
            lang,
          method: "GET",
          data: {},
        })
      );
      break;
    }

    case SITES_AREAS_EQS: {
      const usernodeid = JSON.parse(getItem("usernodeid"));

      const legalentitynodeid = JSON.parse(getItem("legalentitynodeid"));
      next(
        apiRequest({
          url:
            `${SERVER_URL}/sitesareasequipments?legalentitynodeid=` +
            encodeURIComponent(legalentitynodeid) +
            "&usernodeid=" +
            encodeURIComponent(usernodeid) +
            "&lang=" +
            lang,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    case SITES_AREAS_EQS2: {
      const usernodeid = JSON.parse(getItem("usernodeid"));

      const legalentitynodeid = JSON.parse(getItem("legalentitynodeid"));
      next(
        apiRequest({
          url:
            `${SERVER_URL}/sitesareasequipments2?legalentitynodeid=` +
            encodeURIComponent(legalentitynodeid) +
            "&usernodeid=" +
            encodeURIComponent(usernodeid) +
            "&lang=" +
            lang,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    case ALL_SITES_AREAS_EQS: {
      const legalentitynodeid = "247fn://247uptime.io/pfizerpharmatest1gmbh-legalentity1";
      next(
        apiRequest({
          url:
            `${SERVER_URL}/allsitesareasequipments?${"lang=" +
              lang}&&legalentitynodeid=` +
            encodeURIComponent(legalentitynodeid),
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    case ASSIGN_SAE: {
      next(
        apiRequest({
          url: `${SERVER_URL}/users/assign-sae`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case BRANDS_TYPES_EQUIPMENTS: {
      const legalentitynodeid = JSON.parse(getItem("legalentitynodeid"));
      next(
        apiRequest({
          url:
            `${SERVER_URL}/brands-types-equipments?legalentitynodeid=` +
            encodeURIComponent(legalentitynodeid) +
            "&lang=" +
            lang,
          method: "GET",
          data: {},
        })
      );
      break;
    }

    /* 2fa */

    case GENERATE_2FA: {
      next(
        apiRequest({
          url: `${SERVER_URL}/2fa/generate`,
          method: "POST",
          op: action.optype,
        })
      );
      break;
    }
    case AUTHENTICATE_2FA: {
      next(
        apiRequest({
          url: `${SERVER_URL}/2fa/authenticate`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    /* KPIS */
 
    case KPIS: {
      next(
        apiRequest({
          url: `${SERVER_URL}/kpis`,
          method: "POST",
          data: action.payload,
          op: action.optype,
        })
      );
      break;
    }

    case GET_UNITS: {
      next(
        apiRequest({
          url: `${SERVER_URL}/units`,
          method: "GET",
          op: action.optype,
        })
      );
      break;
    }

    default:
      break;
  }
};
